<form class="passport-chooser" [formGroup]="form" appFormFields (ngSubmit)="onPassport()">
  <app-form-field name="passport" [options]="passportOptions()"></app-form-field>
  <button type="submit" mat-button class="button button_primary" (click)="onPassport()">
    {{ labels.buttonText }}
  </button>
</form>
